"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.PlatformMerchantContractBuilder = exports.MerchantDeliveryType = exports.PlatformMerchantContract = void 0;
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var PlatformMerchantContract = /** @class */ (function () {
    function PlatformMerchantContract() {
    }
    PlatformMerchantContract.isActive = function (contract) {
        var nowInMillis = core_common_logic_1.CommonLogic.nowToDateTime()
            .plus({ day: 1 })
            .toMillis();
        return contract.startsAt.toMillis() <= nowInMillis && nowInMillis <= contract.endsAt.toMillis();
    };
    return PlatformMerchantContract;
}());
exports.PlatformMerchantContract = PlatformMerchantContract;
var MerchantDeliveryType;
(function (MerchantDeliveryType) {
    MerchantDeliveryType["WAREHOUSE"] = "WAREHOUSE";
    MerchantDeliveryType["DROPSHIP"] = "DROPSHIP";
})(MerchantDeliveryType = exports.MerchantDeliveryType || (exports.MerchantDeliveryType = {}));
var PlatformMerchantContractBuilder = /** @class */ (function () {
    function PlatformMerchantContractBuilder(contract) {
        this.contract = contract;
    }
    PlatformMerchantContractBuilder.initiateWithContract = function (newContract) {
        return new PlatformMerchantContractBuilder(newContract);
    };
    PlatformMerchantContractBuilder.initiate = function (producerPartyId, producerDeliveryUnitId, merchantPartyId, delivery, platformSaleCatalogId) {
        return new PlatformMerchantContractBuilder({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            producerPartyId: producerPartyId,
            producerDeliveryUnitId: producerDeliveryUnitId,
            merchantPartyId: merchantPartyId,
            delivery: delivery,
            platformSaleCatalogId: platformSaleCatalogId,
            startsAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            endsAt: core_common_logic_1.CommonLogic.nowToDateTime().plus({ years: 5 }),
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    PlatformMerchantContractBuilder.prototype.getId = function () {
        return this.contract.id;
    };
    PlatformMerchantContractBuilder.prototype.withId = function (id) {
        this.contract.id = id;
        return this;
    };
    PlatformMerchantContractBuilder.prototype.resetStartDateToNow = function () {
        return this.resetStartToReferenceStartDate(core_common_logic_1.CommonLogic.nowToDateTime());
    };
    PlatformMerchantContractBuilder.prototype.resetEndDateToNow = function () {
        this.contract = __assign(__assign({}, this.contract), { endsAt: core_common_logic_1.CommonLogic.nowToDateTime(), updatedAt: core_common_logic_1.CommonLogic.nowToDateTime() });
        return this;
    };
    PlatformMerchantContractBuilder.prototype.resetStartToReferenceStartDate = function (referenceStartDate) {
        this.contract = __assign(__assign({}, this.contract), { startsAt: referenceStartDate, createdAt: core_common_logic_1.CommonLogic.nowToDateTime(), endsAt: referenceStartDate.plus({ years: 5 }), updatedAt: core_common_logic_1.CommonLogic.nowToDateTime() });
        return this;
    };
    PlatformMerchantContractBuilder.prototype.build = function () {
        return this.contract;
    };
    PlatformMerchantContractBuilder.prototype.buildUpdate = function () {
        return {
            producerPartyId: this.contract.producerPartyId,
            producerDeliveryUnitId: this.contract.producerDeliveryUnitId,
            merchantPartyId: this.contract.merchantPartyId,
            delivery: this.contract.delivery,
            platformSaleCatalogId: this.contract.platformSaleCatalogId,
            startsAt: this.contract.startsAt,
            endsAt: this.contract.endsAt
        };
    };
    return PlatformMerchantContractBuilder;
}());
exports.PlatformMerchantContractBuilder = PlatformMerchantContractBuilder;
